import Vue from 'vue';
import axios from 'axios';
import trace from './trace';
import FormErrors from './components/form-errors';
import FormErrorList from './components/form-error-list';
import FormSuccessMessage from './components/form-success-message';
import { formErrorComputed, formErrorData, formErrorMethods } from './helpers/index.mjs';

const contactBlockDefinition = {
    components : {
        'form-success'    : FormSuccessMessage,
        'form-error-list' : FormErrorList,
        'form-errors'     : FormErrors
    },
    data : {
        ...formErrorData,

        submit_url : null,

        name    : '',
        email   : '',
        enquiry : '',

        success_message : '',
        is_loading      : false
    },
    computed : {
        ...formErrorComputed
    },
    methods : {
        ...formErrorMethods,

        onSubmitClick( event ) {
            event.preventDefault();
            if( this.is_loading )
                return;

            const payload = {
                // These are prefixed to prevent collisions with
                // other validation message containers - ('CBL' = 'Contact Block Large')
                'cbl-name'    : this.name,
                'cbl-email'   : this.email,
                'cbl-enquiry' : this.enquiry,
            };

            this.is_loading      = true;
            this.success_message = '';
            this.clearAllErrors();

            axios.post( this.submit_url, payload )
                .then( response => this.onSuccessResponse(response) )
                .catch( error   => this.onErrorResponse(error) )
                .finally( () => {
                    this.is_loading = false;
                })
            ;
        },

        onSuccessResponse( response ) {

            trace.log( 'API success response:', response );

            if( ! response.data.sent ) {
                console.warn( 'Check response:', response );
            }

            this.success_message = 'Your message has been sent. Someone will be in touch.';

            this.name    = '';
            this.email   = '';
            this.enquiry = '';
        },

        onErrorResponse( error ) {

            trace.error( 'API error response', error );

            if( error.response && error.response.status === 422 ) {
                const field_errors = error.response?.data || {};

                for( let key in field_errors ) {
                    if( field_errors.hasOwnProperty(key) )
                        this.setErrors( key, field_errors[key] )
                }
                return;
            }

            throw error;
        }
    },
    mounted() {
        this.submit_url = this.$refs['form'].action;
    }
};

let contactBlocks = document.getElementsByClassName('section contact large');

for( let element of contactBlocks ) {
    new Vue({
        ...contactBlockDefinition,
        el : element
    });
}
